import { Draw, Nullable } from '@Models';
import { TeamArmyView } from '../../create/view/TeamArmyView';

export class DrawView {
  item: Nullable<Draw>;
  displayDraw: boolean;
  displayResponse: boolean;
  my: boolean;
  teamArmy: DrawMyArmyView;
  proposition: DrawPropositionView;
  selection: DrawSelectionView;

  constructor(params: DrawViewParams) {
    this.item = params.item;
    this.displayDraw = params.displayDraw;
    this.displayResponse = params.displayResponse;
    this.my = params.my;
    this.teamArmy = params.teamArmy;
    this.proposition = params.proposition;
    this.selection = params.selection;
  }
}

export type DrawViewParams = {
  item: Nullable<Draw>;
  displayDraw: boolean;
  displayResponse: boolean;
  my: boolean;
  teamArmy: DrawMyArmyView;
  proposition: DrawPropositionView;
  selection: DrawSelectionView;
};

export class DrawMyArmyView {
  teamArmy: Nullable<TeamArmyView>;
  selected: boolean;
  confirmed: boolean;

  constructor(params: DrawMyArmyViewParams) {
    this.teamArmy = params.teamArmy;
    this.selected = params.selected;
    this.confirmed = params.confirmed;
  }
}

export type DrawMyArmyViewParams = {
  teamArmy: Nullable<TeamArmyView>;
  selected: boolean;
  confirmed: boolean;
};

export class DrawPropositionView {
  teamArmyOne: Nullable<TeamArmyView>;
  teamArmyTwo: Nullable<TeamArmyView>;
  selected: boolean;
  confirmed: boolean;

  constructor(params: DrawPropositionViewParams) {
    this.teamArmyOne = params.teamArmyOne;
    this.teamArmyTwo = params.teamArmyTwo;
    this.selected = params.selected;
    this.confirmed = params.confirmed;
  }
}

export type DrawPropositionViewParams = {
  teamArmyOne: Nullable<TeamArmyView>;
  teamArmyTwo: Nullable<TeamArmyView>;
  selected: boolean;
  confirmed: boolean;
};

export class DrawSelectionView {
  teamArmy: Nullable<TeamArmyView>;
  selected: boolean;
  confirmed: boolean;

  constructor(params: DrawSelectionViewParams) {
    this.teamArmy = params.teamArmy;
    this.selected = params.selected;
    this.confirmed = params.confirmed;
  }
}

export type DrawSelectionViewParams = {
  teamArmy: Nullable<TeamArmyView>;
  selected: boolean;
  confirmed: boolean;
};
